type ResetElementScrollParams = {
  selectorBy: 'id' | 'className';
  selector: string;
};

export function resetElementScroll({
  selector,
  selectorBy
}: ResetElementScrollParams) {
  const selectorPrefix = {
    id: '#',
    className: '.'
  };

  const containerEl = document.querySelector(
    selectorPrefix[selectorBy] + selector
  );

  if (containerEl) {
    containerEl.scrollTop = 0;
  }
}
